module.exports = __webpack_public_path__ + "static/media/web-grid.dc7784e2.svg";